import React from 'react';
import packageVersionAsClassName from '../packages/react/src/utils/package-version-as-className.mjs';

// A wrapper div that applies the version number as a className to scope our CSS to a specific version. Used in Base, Tooltip and any other component that needs styling outside of Base.
const VersionScopedBase = ({ children }) => {
    return React.createElement("div", { className: packageVersionAsClassName }, children);
};

export { VersionScopedBase as default };
//# sourceMappingURL=VersionScopedBase.mjs.map
